import { list } from 'postcss';
import { _getProdList, _download } from '../../../static/api/index'
import { preloadImage, pxToRem } from '../../../static/utils/index'
import moment from 'moment';
export default {
  name: "App",
  props: {
    parentMenuItem: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      moment,
      // 选中区域
      areaValue: "",
      // 动画时次列表高亮索引
      current: localStorage.getItem("image-time") || 0,
      // 区域列表
      areaOptions: [],
      // 产品时次信息
      prodImgList: {},
      // 渲染的产品图列表长度
      imgLen: 2,
      // imgView: [],
      // url的后缀类型 如：mp4等
      urlType: '',

      // 动画
      isPlay: true,
      // 动画图url
      loopImgUrl: '',
      // 定时器索引，w.fE.timeListDefaultLength定时器默认的最大索引，列表默认展示的数量
      timerIndex: window.fyEarth.timeListDefaultLength,
      // 查看更多时次列表
      timeListDefaultLen: 0,
      // 动画定时器
      timerInterval: null,
      // 动画时间信息等
      imgTime: {},
      // baseData: [],
      // downloadType: true,
      // 源数据列表
      sourceData: [],
      // 数据列表
      timeList: [],
      centerDialogVisible: false,
      // 控制是否开启鼠标移动
      isMousedown: false,
      // 开启滚轮缩放
      isHover: false,
      // 移动的位置
      moveStart: {},
      // 缩放的坐标
      translate: {x: 0, y: 0},
      // 缩放的大小
      scale: 1,
      // 缩放的最大值和最小值
      scaleZoom: {
        max: 5,
        min: 0.2
      },
      // 极窝温度判断名字，与接口prodName配置对应
      PVT_proName: window.fyEarth.PVT_proName,
      // 当前时次列表所有时次是否为单产品
      isOneProduct: false,
      cesClass: {
        width:'1280px',
        height: '560px'
      }
    };

  },
  watch: {
    parentMenuItem: {
      handler(newValue) {
        // 有区域时走区域选择逻辑，无区域时直接获取时次列表
        if(Object.keys(newValue).length > 0 && newValue.region && newValue.region.length > 0){
          let area = this.parentMenuItem.region[0].enName
          this.changeOption([area])
        }
        if(Object.keys(newValue).length > 0 && newValue.region.length == 0) {
          this.getProdList()
        }
      },
      // immediate: true
    },
  },
  created() {},
  mounted(){
    this.upDownChangeTimeList()
    window.addEventListener('mousewheel', this.handleScroll, false)
    let mode = this.$router.history.current.query.mode
    if(mode == 'fullscreen'){
      document.getElementById("historyTitle").style.display = "block";
      document.getElementById("header").style.display = "none";
      document.getElementById("sliderBox").style.display = "none";
      document.getElementById("more").style.display = "none";
      document.getElementById("mainBox").style.height = "calc(100vh - 48px)";
      document.getElementById("mainBox").style.width = "calc(100% - 20px)"
      document.getElementById("main").style.height = "100vh";
    }
  },
  beforeDestroy() {
    clearInterval(this.timerInterval)
    this.timerInterval = null
  },
  methods: {
    pxToRem,
    // 选择区域
    changeOption(value) {
      this.areaValue = value
      localStorage.setItem('area', value)
      if (value.length) {
        this.areaOptions = this.region_array(this.parentMenuItem.region)
        // clearInterval(this.timerInterval)
        // this.timerInterval = null
        this.getProdList()
      } else {
        this.timeList = []
      }
    },
    // 获取产品数据
    getProdList() {
      const prodName = localStorage.getItem('prodName')
      const dataType = localStorage.getItem('dataType')
      const prodCode = localStorage.getItem('prodCode')
      let params = {}
      if(dataType !== 'undefined'){
        params = {
          abbr: prodName,
          region: this.$store.state.regionLength == 0 ? 'Global' : this.areaValue,
          dataType: dataType,
          language: window.fyEarth.language,
          code: prodCode
        }
      } else {
        params = {
          abbr: prodName,
          region: this.$store.state.regionLength == 0 ? 'Global' : this.areaValue,
          language: window.fyEarth.language,
          code: prodCode
        }
      }      
      this.timeList = []
      this.prodImgList = {}
      this.sourceData = []
      let _data = []
      const mode = this.$router.history.current.query.mode
      clearInterval(this.timerInterval)
      this.timerInterval = null
      _getProdList(this.$store.state.logo, params).then((result) => {
        _data = result.data
        this.setProd(_data, mode)
      })
    },
    setProd(_data, mode){
      if (_data.length) {
        // 判断当前产品下所有时次是否为单产品
        _data.forEach((_item)=>{
          this.isOneProduct = false
          if(_item.list.length == 1){
            this.isOneProduct = true
          }
          return this.isOneProduct
        })
        if(mode === 'fullscreen'){
          this.timeList = _data
          this.timeListDefaultLen = _data.length
          this.timerIndex = _data.length
        } else {				
          // 需求：默认展示18条，点击more展示40条 注：接口返回40条信息
          this.timeListDefaultLen = _data.length > window.fyEarth.timeListDefaultLength ? window.fyEarth.timeListDefaultLength : _data.length
          this.timeList = _data.slice(0, this.timeListDefaultLen)
          this.timerIndex = this.timeListDefaultLen
        }
        this.sourceData = this.timeList
        // console.log('prodType',this.parentMenuItem.prodType, '是否为单产品', this.isOneProduct)
        // prodType 类型为 video时，左侧时次列表不显示 类型不为视频时，调用时次数据 video img animation 添加容错：prodType为空或undefined时默认为img
        // prodType 类型为 animation 和为单产品时，开启动画模式
        if (this.parentMenuItem.prodType === 'animation' && this.isOneProduct) {
          /* 初始化图片 */
          this.prodImgList = _data[0]
          this.loopImgUrl = _data[0].list[0].url
          this.imgTime = _data[0]
          // 当前进度值
          this.current = 0 
          this.$nextTick(() => {
            // 预加载图像
            preloadImage(this.sourceData)
            // 判断图片自适应方式
            const width = window.screen.width
            let imgDom = document.getElementById('loopImgDom')
            if(this.prodImgList.list[0].width / this.prodImgList.list[0].height > 1.8){
              imgDom.style.width = '100%'
              imgDom.style.height = 'auto'
              if(this.parentMenuItem.prodName == 'ACS' || this.parentMenuItem.abbr == 'Circulation' || this.parentMenuItem.code == '01010205'){
                if(width >= 1920){
                  imgDom.style.width = 'auto'
                  imgDom.style.height = '100%'
                } else {
                  imgDom.style.width = '100%'
                  imgDom.style.height = 'auto'
                }
              }
            } else {
              imgDom.style.width = 'auto'
              imgDom.style.height = '100%'
            }
          })
          // 除Image页外，动画默认不播放
          // if(this.$store.state.navTitle === 'Image'){
          //   this.start()
          // } 
        } else if(this.parentMenuItem.prodType === 'video'){
          this.prodImgList = _data[0]
          let name = _data[0].list[0].url.split('.')
          this.urlType = name[name.length - 1]
        } else {
          // 选择时次
          // this.loopImgUrl = ''
          // this.imgTime = {}
          this.changeTime(this.timeList[0], 0)
        }
      }
    },
    // 播放
    start() {
      this.loopImg()
      this.isPlay = false;
      this.timerInterval && clearInterval(this.timerInterval)
      this.timerInterval = null
      this.timerInterval = setInterval(() => {
        this.loopImg()
      }, window.fyEarth.animationSpeed)
    },

    // 图片loop
    loopImg() {
      this.timerIndex--
      if (this.timerIndex >= 0) {
        this.loopImgUrl = this.timeList[this.timerIndex].list[0].url
        this.imgTime = this.timeList[this.timerIndex]
        // 当前进度值
        this.current = this.timerIndex
      } else {
        this.timerIndex = this.timeListDefaultLen
      }
    },
    // 改造区域数据结构
    region_array(dataParams) {
      var _this = this
      var data = []
      dataParams.forEach(function (v) {
        var city_one = { value: v.enName, label: v.enName }
        if (v.children.length) {
          city_one.children = _this.region_array(v.children)
        }
        // else {
        //     city_one.children = []
        // }
        data.push(city_one)
      });

      return data;
    },
    // 选择时次
    changeTime(prod, index) {
      clearInterval(this.timerInterval)
      this.timerInterval = null
      this.isPlay = true
      this.timerIndex = index
      localStorage.setItem("image-time", index)
      this.current = index
      // 渲染产品图
      this.prodImgList = prod
      this.imgLen = prod.list.length
      // 渲染动画
      this.loopImgUrl = prod.list[0].url
      this.imgTime = prod
    },
    // 查看更多
    moreData() {
      window.open(window.location.href + '?mode=fullscreen')
    },
    // 播放
    play() {
      this.isPlay = false;
      this.start()
    },
    // 暂停
    paused() {
      this.isPlay = true
      this.timerInterval && clearInterval(this.timerInterval)
      this.timerInterval = null
    },
    // 上一帧
    prevFrame() {
      this.isPlay = true
      this.timerInterval && clearInterval(this.timerInterval)
      this.timerInterval = null
      if (this.timerIndex >= this.timeList.length - 1) {
        this.timerIndex = 0
      } else {
        this.timerIndex++
      }
      this.loopImgUrl = this.timeList[this.timerIndex].list[0].url
      this.imgTime = this.timeList[this.timerIndex]
      // 当前进度值
      this.current = this.timerIndex
    },
    // 下一帧
    nextFrame() {
      this.isPlay = true
      this.timerInterval && clearInterval(this.timerInterval)
      this.timerInterval = null
      if (this.timerIndex <= 0) {
        this.timerIndex = this.timeList.length - 1
      } else {
        this.timerIndex--
      }
      this.loopImgUrl = this.timeList[this.timerIndex].list[0].url
      this.imgTime = this.timeList[this.timerIndex]
      // 当前进度值
      this.current = this.timerIndex
    },
    // 下载zip/mp4/gif文件
    download(type){
      const prodName = localStorage.getItem('prodName')
      let params = {
        abbr: prodName,
        region: this.$store.state.regionLength == 0 ? '' : this.areaValue
      }
      _download(this.$store.state.logo, type, params).then((res)=>{
        //console.log(type, 'res', res, )
        const blob = new Blob([res.data]); // 如类型为excel,type为：'application/vnd.ms-excel'
        const fileName = res.headers.filename || `${prodName}.${type}`;
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // 点击后移除，防止生成很多个隐藏a标签
      })
    },
    // 监听键盘，控制上下键选择时次列表
    upDownChangeTimeList() { 
      document.onkeydown = (e) => {
        //事件对象兼容
        let e1 = e || event || window.event || arguments.callee.caller.arguments[0]
        //键盘按键判断:左箭头-37;上箭头-38；右箭头-39;下箭头-40
        if (e1 && e1.keyCode == 38) {
          this.nextFrame()
        } else if (e1 && e1.keyCode == 40) {
          this.prevFrame()
        }
      }
    },
    // 动画暂停，点击图片查看大图
    bigImage(imgData){
      if(this.isPlay){
        this.centerDialogVisible = true
        this.imgTime = {
          list: [
            imgData
          ]
        }
      }
    },
    // 没有时次列表时,查看大图
    bigImg(imgData){
      this.centerDialogVisible = true
      this.imgTime.list = imgData
    },
    // 关闭弹窗
    close(){
      this.centerDialogVisible = false
      this.isHover = false
    },
    // 鼠标按下事件 拖动图片文件
    mousedownDragImg(e){
      e.preventDefault()
      
      // 获取元素
      var zoomBox = document.querySelector('.dragElement')
      var imgInfo = this.$refs.dragElement
      var x = e.pageX - imgInfo.offsetLeft
      var y = e.pageY - imgInfo.offsetTop
      imgInfo.style.margin = 'auto'

      // 添加鼠标移动事件
      zoomBox.addEventListener('mousemove', move)
    
      function move(e) {
        imgInfo.style.left = e.pageX - x + 'px'
        imgInfo.style.top = e.pageY - y + 'px'
      }
      // 添加鼠标抬起事件，鼠标抬起，将事件移除
      imgInfo.addEventListener('mouseup', function() {
        zoomBox.removeEventListener('mousemove', move)
      })
      // 鼠标离开元素，把事件移除
      zoomBox.addEventListener('mouseout', function() {
        zoomBox.removeEventListener('mousemove', move)
      })
      // 鼠标抬起事件 移除事件
      zoomBox.addEventListener('mouseup', function() {
        zoomBox.removeEventListener('mousemove', move)
      })
    },
    // 鼠标滚轮事件，开启缩放
    handleScroll(e) {
      if(this.isHover) {
        let speed = e.wheelDelta / 120
        if(e.wheelDelta > 0 && this.scale < this.scaleZoom.max) {
          this.scale += 0.2 * speed
          this.$refs.dragElement.style.transform = `scale(${this.scale}) translate(${this.translate.x}px, ${this.translate.y}px)`
        }else if(e.wheelDelta < 0 && this.scale > this.scaleZoom.min){
          this.scale += 0.2 * speed
          this.$refs.dragElement.style.transform = `scale(${this.scale}) translate(${this.translate.x}px, ${this.translate.y}px)`
        }
      }
    },
  },
};